import { toCents } from '@horof/shared';

/**
 * Display helpers for arqam's totals (doc 55). The amounts themselves come
 * from the API; nothing here adds money up.
 */

type MonthTotal = { key: string | null; income: string; expenses: string };

/** The 12 months of `year` ("2026"), with arqam's totals where there are. */
export function fillMonths(rows: (MonthTotal | null)[], year: string) {
  const byKey = new Map(
    rows.flatMap((r) => (r?.key ? [[r.key, r] as const] : [])),
  );
  return Array.from({ length: 12 }, (_, i) => {
    const month = `${year}-${String(i + 1).padStart(2, '0')}`;
    const row = byKey.get(month);
    return {
      month,
      income: row?.income ?? '0.00',
      expenses: row?.expenses ?? '0.00',
    };
  });
}

/** A share of a total, 0–100, for the bars (a proportion, not money). */
export const share = (part: string, total: string) => {
  const t = toCents(total);
  return t === 0
    ? 0
    : Math.round((Math.abs(toCents(part)) / Math.abs(t)) * 100);
};
